import {
  IconArrowRight,
  IconCalendarEvent,
  IconPlaneArrival,
  IconPlaneDeparture,
} from "@tabler/icons-react";
import moment from "moment";
import React from "react";

const FlightCard = ({ flight }) => {
  function getFlightStage( status) {
    let stage = status;
    let color = "#2B9950"; // default grey

    // Priority: use status if it's clear
    // switch (status) {
    //   case "scheduled":
    //     stage = "Scheduled";
    //     color = "#2B9950"; // grey
    //     break;
    //   case "departed":
    //     stage = "Departed";
    //     color = "#DC3532"; // blue
    //     break;
      
    //    case "in air":
    //     stage = "In Air";
    //     color = "#ff9800"; // blue
    //     break;
    //   case "arrived":
    //     stage = "Arrived";
    //     color = "#28a745"; // green
    //     break;
    //   case "cancelled":
    //     stage = "Cancelled";
    //     color = "#dc3545"; // red
    //     break;
    //    case "cancel":
    //     stage = "Cancel";
    //     color = "#dc3545"; // red
    //     break;
    //   case "diverted":
    //     stage = "Diverted";
    //     color = "#ff9800"; // orange
    //     break;
    //   case "redirected":
    //     stage = "Redirected";
    //     color = "#ff9800"; // orange
    //     break;
    //    case "delayed":
    //     stage = "Delayed";
    //     color = "#ff9800"; // orange
    //     break;
    //   case "U":
    //     stage = "Unknown";
    //     color = "#6c757d"; // dark grey
    //     break;
    //   default:
    //     // If status isn't enough, check actual times
    //    stage = "_";
    //     color = "#6c757d";
    //     break;
    // }

    return (
      <p
        className="flight-card-status"
        style={{
          padding: "4px 8px",
          borderRadius: "4px",
          backgroundColor: color,
          color: "#fff",
          fontWeight: "bold",
          fontSize: "0.9rem",
          width: "fit-content",
          textTransform:"capitalize !important"
        }}
      >
        {stage}
      </p>
    );
  }


const dateFormat = (dateString, timeZone) => {
  if (!dateString) return "";

  try {
    const tz = timeZone || "UTC"; // fallback to UTC
    const dateObj = new Date(dateString);
    if (isNaN(dateObj)) return "";

    const day = new Intl.DateTimeFormat("en-GB", { day: "numeric", timeZone: tz }).format(dateObj);
    const monthName = new Intl.DateTimeFormat("en-GB", { month: "short", timeZone: tz }).format(dateObj);
    const year = new Intl.DateTimeFormat("en-GB", { year: "numeric", timeZone: tz }).format(dateObj);

    const time = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: tz,
    }).format(dateObj);

    return `${day} ${monthName} ${year}, ${time}`;
  } catch (err) {
    console.error("Invalid date or timezone", err);
    return "";
  }
};




  function formatDateTime(input) {
    if (!input) return "N/A";

    const dateStr = input.slice(0, 16);

     const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
  return regex.test(dateStr) ? moment(dateStr).format("DD MMM YYYY, HH:mm") : "N/A";
    console.log(dateStr)
    return moment(dateStr).format("DD MMM YYYY, HH:mm");

    // Case: input like "2025-08-04+00:00" → show "N/A"
    if (/^\d{4}-\d{2}-\d{2}\+00:00$/.test(input.trim())) {
      return "N/A";
    }

    // Remove anything from '+' onwards (timezone)
    const cleanInput = input.split("+")[0].trim();

    const hasTime = cleanInput.includes(":");
    let [datePart, timePart] = cleanInput.split(" ");
    const [year, month, day] = datePart.split("-");

    if (!year || !month || !day) return "N/A";

    if (timePart && timePart.includes("-")) {
      // Remove timezone if present
      timePart = timePart.split("-")[0].trim();
    }

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const formattedDate = `${day} ${monthNames[parseInt(month) - 1]} ${year}`;

    return hasTime ? `${formattedDate}, ${timePart}` : formattedDate;
  }

  return (
    <div className="flight-card" style={{ position: "relative" }}>
      <div className="flight-header">
        <div className="flight-header-left">
          <span className="flight-airline-names">
            {flight.departure.iata}{" "}
            <IconArrowRight size={"18px"} color="#222" />
            {flight.arrival.iata}
          </span>
          <span className="flight-airport-names">
            {flight.departure.airport} to {flight.arrival.airport}
          </span>
        </div>
        {/* <span className={`status ${flight.flight_status}`}>
          {flight.flight_status.toUpperCase()}
        </span> */}

        {getFlightStage( flight?.flight_status)}
        <div className="flight-header-right flight-number-wrapper">
          <span className="flight-date">
            <IconCalendarEvent size={"25px"} color="#222" />{" "}
            { moment(flight.flight_date).format("DD MMM YYYY")}
          </span>
          <span className="flight-number">{flight.flight_number}</span>
        </div>
      </div>
      <div className="flight-section">
        {/* <div className="flight-dots">
          <span className="dot"></span>
          <span className="dots"></span>

          <span className="dot"></span>
        </div> */}
        <div className="flight-details-wrapper">
          <div>
            <h5 className="departure-arrival">
              <IconPlaneDeparture /> Departure
            </h5>
            <div className="flight-details-top">
              <div className="flight-details-left">
                <span className="flight-airline-names">
                  {flight.departure.airport} {flight.departure.iata && `(${flight.departure.iata})`}
                </span>
                {/* <span className="flight-airport-names">
                  {
                    flight.departure.terminal && flight.departure.terminal !== "" && `Terminal ${flight.departure.terminal}`
                  }

                   {
                    flight.departure.terminal && flight.departure.terminal !== "" && flight.departure.timezone && flight.departure.timezone !== "" && `, `
                  }

                   {
                    flight.departure.timezone && flight.departure.timezone !== "" && ` Timezone: ${flight.departure.timezone}`
                  }
                 
                </span> */}

                 <span className="flight-airport-names">
                  {
                    flight.departure.terminal && flight.departure.terminal !== "" && `Terminal ${flight.departure.terminal}`
                  }

                  

                  
                 
                </span>

                <span className="flight-airport-names">
                   {
                    flight.departure.timezone && flight.departure.timezone !== "" && ` Timezone: ${flight.departure.timezone}`
                  }
                </span>
              </div>

              <div className="flight-details-right">
                {flight.departure.scheduled && flight.departure.scheduled  !== "+00:00"   && (
                <span className="flight-date">
                  <span>Scheduled</span>{" "}
                  {dateFormat(flight.departure.scheduled,flight.departure.timezone)}
                </span>
                 )} 

                {flight.departure.estimated && flight.departure.estimated !== "+00:00" && (
                <span className="flight-date">
                  <span>Estimated</span>{" "}
                  {dateFormat(flight.departure.estimated,flight.departure.timezone)}
                </span>
                )} 

                {flight.departure.actual && flight.departure.actual !== "+00:00" && flight.departure.actual_runway && flight.departure.actual_runway !== "+00:00"  && (
                <span className="flight-date">
                  <span>Actual</span> {dateFormat(flight.departure.actual,flight.departure.timezone)}
                </span>
               )}

                {flight.departure.actual_runway && flight.departure.actual_runway !== "+00:00"  && (
                <span className="flight-date">
                  <span>Actual Runway</span>{" "}
                  {dateFormat(flight.departure.actual_runway,flight.departure.timezone)}
                </span>
)} 
              </div>
            </div>
          </div>

          <div>
            <h5 className="departure-arrival">
              <IconPlaneArrival /> Arrival
            </h5>
            <div className="flight-details-top">
              <div className="flight-details-left">
                <span className="flight-airline-names">
                  {flight.arrival.airport} {flight.arrival.iata && `(${flight.arrival.iata})`}
                </span>
                {/* <span className="flight-airport-names">
                  {
                    flight.arrival.terminal && flight.arrival.terminal !== "" && `Terminal ${flight.arrival.terminal}`
                  }

                  {
                    flight.arrival.terminal && flight.arrival.terminal !== "" && flight.arrival.timezone && flight.arrival.timezone !== "" && `,`
                  }

                   {
                    flight.arrival.timezone && flight.arrival.timezone !== "" && ` Timezone: ${flight.arrival.timezone}`
                  }
                </span> */}

                <span className="flight-airport-names">
 {
                    flight.arrival.terminal && flight.arrival.terminal !== "" && `Terminal ${flight.arrival.terminal}`
                  }
                </span>

                  <span className="flight-airport-names">
  {
                    flight.arrival.timezone && flight.arrival.timezone !== "" && ` Timezone: ${flight.arrival.timezone}`
                  }
                </span>
              </div>

              <div className="flight-details-right">
                {flight.arrival.scheduled && flight.arrival.scheduled !== "+00:00" && (
                <span className="flight-date">
                  <span>Scheduled</span>{" "}
                  {dateFormat(flight.arrival.scheduled,flight.arrival.timezone)}
                </span>
)}

                {flight.arrival.estimated && flight.arrival.estimated !== "+00:00" && (
                <span className="flight-date">
                  <span>Estimated</span>{" "}
                  {dateFormat(flight.arrival.estimated,flight.arrival.timezone)}
                </span>
                 )} 

                {flight.arrival.actual && flight.arrival.actual !== "+00:00" && flight.arrival.actual_runway && flight.arrival.actual_runway !== "+00:00"  && (
                <span className="flight-date">
                  <span>Actual</span> {dateFormat(flight.arrival.actual,flight.arrival.timezone)}
                </span>
                )} 

                {flight.arrival.actual_runway && flight.arrival.actual_runway !== "+00:00"  && (
                <span className="flight-date">
                  <span>Actual Runway</span>{" "}
                  {dateFormat(flight.arrival.actual_runway,flight.arrival.timezone)}
                </span>
                )} 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    // <div className="flight-card">
    //   <div className="flight-header">
    //     <h2>
    //       {flight.flight.iata} — {flight.airline.name}
    //     </h2>
    //     <span className={`status ${flight.flight_status}`}>
    //       {flight.flight_status.toUpperCase()}
    //     </span>
    //   </div>

    //   <div className="flight-section">
    //     <h4>📅 Flight Date</h4>
    //     <p>{formatDate(flight.flight_date)}</p>
    //   </div>

    //   <div className="flight-columns">
    //     <div className="flight-section">
    //       <h4>🛫 Departure</h4>
    //       <p>
    //         <strong>{flight.departure.airport}</strong> ({flight.departure.iata}
    //         )
    //       </p>
    //       <p>Terminal: {flight.departure.terminal}</p>
    //       <p>Scheduled: {formatDate(flight.departure.scheduled)}</p>
    //     </div>

    //     <div className="flight-section">
    //       <h4>🛬 Arrival</h4>
    //       <p>
    //         <strong>{flight.arrival.airport}</strong> ({flight.arrival.iata})
    //       </p>
    //       <p>Terminal: {flight.arrival.terminal}</p>
    //       <p>Actual: {formatDate(flight.arrival.actual)}</p>
    //     </div>
    //   </div>

    //   <div className="flight-section">
    //     <h4>✈️ Aircraft</h4>
    //     <p>{flight.aircraft.iata}</p>
    //     <p>Registration: {flight.aircraft.registration}</p>
    //   </div>

    //   <div className="flight-section">
    //     <h4>📄 Flight Number</h4>
    //     <p>{flight.flight.number}</p>
    //   </div>
    // </div>
  );
};

export default FlightCard;
